import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { motion } from 'framer-motion';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex justify-center items-center bg-gradient-to-br from-primary-50 to-accent-50">
                <div className="flex flex-col items-center space-y-8">
                    <motion.div
                        className="relative"
                        animate={{
                            rotate: 360,
                        }}
                        transition={{
                            duration: 2,
                            repeat: Infinity,
                            ease: "linear"
                        }}
                    >
                        <div className="w-32 h-32 border-8 border-primary-200 rounded-full"></div>
                        <motion.div
                            className="absolute inset-0 w-32 h-32 border-8 border-transparent border-t-primary-600 rounded-full"
                            animate={{
                                rotate: -360,
                            }}
                            transition={{
                                duration: 1.5,
                                repeat: Infinity,
                                ease: "linear"
                            }}
                        />
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.5 }}
                        className="text-center space-y-4"
                    >
                        <h3 className="text-2xl font-bold text-neutral-900">
                            Authentifizierung wird überprüft...
                        </h3>
                        <motion.div
                            className="flex justify-center space-x-2"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 1 }}
                        >
                            {[0, 1, 2].map((i) => (
                                <motion.div
                                    key={i}
                                    className="w-4 h-4 bg-primary-500 rounded-full"
                                    animate={{
                                        y: [-10, 10, -10],
                                        scale: [1, 1.2, 1]
                                    }}
                                    transition={{
                                        duration: 1.5,
                                        repeat: Infinity,
                                        delay: i * 0.2
                                    }}
                                />
                            ))}
                        </motion.div>
                    </motion.div>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/admin/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
